// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wo_a bii_b"};